import React, { Component } from 'react';
import './MultiSelectView.scss';
import parse from 'html-react-parser';
import { AddItemButton, ShortenedText } from '../../../../../../UiKit';
import { debounce, padEnd } from 'lodash-es';
import Tag from 'sushiweb/Tag';

export default class MultiSelectView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: {},
      disabled: false,
    };
    this.deb = debounce((selected) => {
      const { selectItems } = this.props;
      selectItems(selected);
    }, 800);
  }

  counterIncrease = (item) => {
    const { selected } = this.state;
    let counterObj = selected;
    if (counterObj[item.value] >= item.max_range) {
      return;
    }
    counterObj[item.value] = counterObj[item.value]
      ? counterObj[item.value] + 1
      : 1;
    this.setState({
      selected: counterObj,
    });
    this.deb(selected);
  };

  counterDecrease = (item) => {
    const { selectItems } = this.props;
    const { selected } = this.state;
    let counterObj = selected;
    if (counterObj[item.value] > 1) {
      counterObj[item.value] = counterObj[item.value]
        ? counterObj[item.value] - 1
        : 0;
    } else {
      delete counterObj[item.value];
    }
    this.setState({
      selected: counterObj,
    });
    selectItems(selected);
  };

  render() {
    const { items } = this.props;
    const { selected, disabled } = this.state;
    let btnCustomStyle = {};

    return (
      <div className='MultiSelectView'>
        {items &&
          items.map((item, index) => {
            let cardMinHeight = {
              minHeight: item.item_image_url ? '10rem' : '3.3rem',
            };
            btnCustomStyle = {
              position: item.item_image_url ? 'absolute' : 'initial',
            };
            return (
              <div className='item' key={index} style={cardMinHeight}>
                <div className='row itemDecription'>
                  {item.primary_tag_image_url && (
                    <div className='itemTag iconMarginR mt3'>
                      <img src={item.primary_tag_image_url} alt='' />
                    </div>
                  )}
                  <div className='col'>
                    <div className='itemName semiBold dark large'>
                      {parse(item.text)}
                    </div>
                    {item.category_name && (
                      <p className='small lighter'>In {item.category_name}</p>
                    )}
                    <div
                      css={`
                        display: flex;
                        gap: 0.5rem;
                        flex-wrap: wrap;
                      `}
                    >
                      {item.tags
                        ? item.tags.map((tag) => (
                            <Tag
                              type='tag'
                              key={tag.slug}
                              label={tag.label}
                              bgColor={tag.bg_color}
                              textColor={tag.color}
                              fontSize={tag.font_size}
                              margin='0.3rem 1rem'
                            />
                          ))
                        : null}
                    </div>
                    {item.description && (
                      <p className='small dark'>
                        <ShortenedText
                          text={item.description}
                          charLimit={55}
                          size='small'
                        />
                      </p>
                    )}

                    {item.unit_cost_text ? (
                      <p className='small dark semiBold'>
                        {`${
                          item.quantity !== null || item.quantity !== undefined
                            ? `${item.quantity} x`
                            : ''
                        } ${item.unit_cost_text} ${
                          item.inventory !== null &&
                          item.inventory !== undefined
                            ? `| inventory: ${item.inventory}`
                            : ''
                        }`}
                      </p>
                    ) : null}
                  </div>
                </div>
                <div className='rightSection col center'>
                  {item.item_image_url && (
                    <div className='itemImageWrapper'>
                      <img src={item.item_image_url} alt='' />
                    </div>
                  )}
                  <div className='btnContainer' style={btnCustomStyle}>
                    <AddItemButton
                      count={selected[item.value] ? selected[item.value] : 0}
                      handleIncrease={this.counterIncrease.bind(this, item)}
                      handleDecrease={this.counterDecrease.bind(this, item)}
                      disabled={
                        disabled || item.disabled || item.max_range === 0
                      }
                      increaseDisabled={selected[item.value] >= item.max_range}
                    />
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    );
  }
}
